export default function dialog() {
  return { dialogs: [] };
}
